export const USER_ROLES = ["cfo", "investor", "other"] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  cfo: "CFO",
  investor: "Investor",
  other: "Other",
};
